module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.7 25.4H4.2V9.8h21.5v15.6zM5.8 23.8h18.3V11.4H5.8v12.4z","fill":"#878787"}}),_c('path',{attrs:{"d":"M10.6 17.7h1.6v7h-1.6zm7.7-7.1h1.6v7h-1.6zM5 16h3.2v1.6H5z","fill":"#878787"}}),_c('circle',{attrs:{"cx":"14.9","cy":"8.4","fill":"#fff","r":"6.6"}}),_c('path',{attrs:{"d":"M11.6 8.7l3.3-4 3.4 4h-2.1v3.6h-2.5V8.7z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/save_floorplan.svg
// module id = 716
// module chunks = 2